


















import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class InstitutionEvolutionTable extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  keyValue: number;

  @Prop({default: "Sem dados"})
  emptyText: number;

  items = [];
  dates = [];

  headers = [];

  mounted() {
    this.load();
  }

  load() {
    if (!this.kpis) {
      return;
    }
    let map = new Map();
    let idsDates = new Set<string>();
    let mapDsDates = new Map();
    let names = new Set<string>();

    this.kpis.forEach((i) => {
      if (!map[i.idPeriodo]) {
        map[i.idPeriodo] = [];
      }
      if (!map[i.idPeriodo][i.nomeInstituicao]) {
        map[i.idPeriodo][i.nomeInstituicao] = [];
      }
      map[i.idPeriodo][i.nomeInstituicao] = i.quantidade;
      idsDates.add(i.idPeriodo);
      mapDsDates[i.idPeriodo] = i.descPeriodo;
      names.add(i.nomeInstituicao);
    });

    let arrayIdDates = Array.from(idsDates).sort();

    let headers = [];
    this.headers = headers;
    headers.push({ text: 'Instituição', value: 'nome', sortable: false });
    arrayIdDates.forEach((d) => {
      headers.push({ text: mapDsDates[d], value: "valores['" + d + "']", sortable: false });
    });

    this.items = [];
    names.forEach((n) => {
      let values = new Map();
      let percents = new Map();
      let previousDay = null;
      arrayIdDates.forEach((d) => {
        values[d] = map[d][n];
        percents[d] = this.calcGrowth(values[previousDay], values[d]);
        previousDay = d;
      });
      this.items.push({
        nome: n,        
        valores: values,
        percents: percents
      });
    });

    this.dates = arrayIdDates;
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }

  calcGrowth(v1, v2) {
    if (!v1) {
      return null;
    }
    if (!v2) {
      v2 = 0;
    }
    if (v1 == v2) {
      return 0;
    }
    return Math.round((v2 / v1 - 1) * 100);
  }
}
